import { useContext } from 'react';

import { ThemeProviderContext } from '@/providers/theme/theme.context';
import type { ThemeProviderState } from '@/providers/theme/theme.provider';

export function useTheme(): ThemeProviderState {
  const context = useContext(ThemeProviderContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }

  return context;
}
